import { useEffect, useState, useCallback } from "react";
import { checkIsDesktop } from "../util/viewport-utils";

export default function useStickyElement() {
  const [isElementSticky, setElementSticky] = useState(false);

  const thresholdValue = checkIsDesktop() ? 50 : 40;

  const handleScroll = useCallback(() => {
    const scrollTop = window.pageYOffset;
    if (!isElementSticky && scrollTop > thresholdValue) {
      setElementSticky(true);
    }
    if (isElementSticky && scrollTop <= thresholdValue) {
      setElementSticky(false);
    }
  }, [isElementSticky, thresholdValue]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isElementSticky, handleScroll, thresholdValue]);

  return { isElementSticky };
}
